import { useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import type { TApiGenericError } from "../../timenotes-query/timenotes-query.types"

interface Props {
  projectId: string
}

interface Args {
  taskId: string
}

export function useArchiveTaskMutation(props: Props) {
  const {
    projectId
  } = props

  const queryClient = useQueryClient()
  const apiClient = useApiClient()

  const mutation = useMutation<{}, TApiGenericError<any>, Args>(
    ["task-archive"],
    async (args: Args) => {
      const {
        taskId
      } = args

      const response = await apiClient.archiveTask(projectId, taskId)

      if (!response.ok) {
        throw response.errors
      }

      return response
    },
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(["project-task", projectId, variables.taskId])
        queryClient.invalidateQueries(["project-sections", projectId], { exact: false })
      },
    }
  )

  return mutation
}
